import { render } from "./VideoWallPresetEditor.vue?vue&type=template&id=6da5fcf6&ts=true"
import script from "./VideoWallPresetEditor.vue?vue&type=script&lang=ts"
export * from "./VideoWallPresetEditor.vue?vue&type=script&lang=ts"

import "./VideoWallPresetEditor.vue?vue&type=style&index=0&id=6da5fcf6&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__